<template>
  <App>
    <div class="row g-5 g-xl-10">
      <!--begin::Col-->
      <div class="col-12">
        <!--begin::Lists Widget 19-->
        <div class="card card-flush h-xl-100">
          <!--begin::Heading-->
          <div class="card-header rounded bgi-no-repeat bgi-size-cover bgi-position-y-top bgi-position-x-center align-items-start h-250px"
               style="background-color: green">
            <!--begin::Title-->
            <h3 class="card-title align-items-start flex-column text-white pt-15">
              <span class="fw-bolder fs-2x mb-3">Olá!</span>
              <div class="fs-4 text-white">
                <span class="opacity-75">Até agora são {{dados.inscricoes}} inscrições, {{dados.orientadores}} orientadores e {{dados.alunos}} alunos.</span>
              </div>
            </h3>
          </div>
          <div class="card-body mt-n20">
            <div class="mt-n20 position-relative">
              <div class="row g-3 g-lg-6">
                <div class="col-3" v-for="(quantidade, camiseta) in dados.camisetas">
                  <div :class="{'bg-gray-100': camiseta, 'bg-light-warning': !camiseta}" class="bg-opacity-70 rounded-2 px-6 py-5">
                    <div class="symbol symbol-30px me-5 mb-8">
                        <span class="symbol-label">
                          <span class="svg-icon svg-icon-1 svg-icon-primary">
                            <i class="bi bi-flag"></i>
                          </span>
                        </span>
                    </div>
                    <div class="m-0">
                      <span class="text-gray-700 fw-boldest d-block fs-2qx lh-1 ls-n1 mb-1">{{quantidade}}</span>
                      <span class="text-gray-600 fw-bold fs-5" v-if="camiseta">Tamanho {{camiseta}}</span>
                      <span class="text-gray-600 fw-bold fs-5" v-else>Tamanho Indefinido</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </App>
</template>
<script>
import App from "@layout/App";
import {Link} from "@inertiajs/inertia-vue3";
import SubmitButton from "@forms/SubmitButton";
import Datepicker from "@forms/Datepicker";
import FormGroup from "@forms/FormGroup";

export default {
  props: ['dados'],

  components: {
    FormGroup,
    Datepicker,
    SubmitButton,
    App,
    Link,
  },

  data: _ => ({

  }),

  mounted() {
    this.init();
  },

  methods: {
    init() {
      this.emitter.emit('title', 'Relatório de Camisetas');
      this.emitter.emit('breadcrumb', [
        {title: 'Dashboard', link: 'app.home'},
        {title: 'Relatório de Camisetas'},
      ]);

      this.emitter.emit('action', {
            show: false,
          }
      );
    },
  },
};
</script>
